import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import SockJsClient from '../common/SockJsClient';
import { requestsActions, userActions } from '../../actions';
import { fetchProgramDelayed } from '../../slices/program-slice';

const WS_CONNECT_URL = '/ws1';
const REQUEST_CHANGE_TOPIC = '/user/queue/requests';
const USER_CHANGE_TOPIC = '/user/queue/users';
const PROGRAM_CHANGE_TOPIC = '/topic/program';
const topics = [REQUEST_CHANGE_TOPIC, USER_CHANGE_TOPIC];

function WSClient(props) {
    const { checkSession, logined, user, getAllRequestsDelayed } = props;
    const dispatch = useDispatch();
    const [isConnected, setIsConnected] = useState(false);
    const stompClientRef = useRef();

    useEffect(() => {
        // на любое изменение авторизованности (логин или логаут) делает реконнект веб-сокетов
        if (isConnected) {
            stompClientRef.current.disconnect(() => {
                stompClientRef.current.connect();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logined]);

    const onMessage = useCallback(
        (message, dst) => {
            console.log('RCV MES', dst, message);
            if (dst === REQUEST_CHANGE_TOPIC || dst === USER_CHANGE_TOPIC) {
                if (dst === USER_CHANGE_TOPIC && user && message && message.userId === user.id) {
                    checkSession();
                }
                getAllRequestsDelayed(message?.serverTS);
                return;
            }
            if (dst === USER_CHANGE_TOPIC) {
                return;
            }
            if (dst === PROGRAM_CHANGE_TOPIC) {
                // Данный код больше не запускается, остался пока для истории
                dispatch(fetchProgramDelayed());
                return;
            }
            console.warn('unknown ws chanel', dst);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [checkSession, getAllRequestsDelayed, dispatch, user]
    );

    const onConnect = useCallback(() => {
        checkSession();
        dispatch(fetchProgramDelayed());
        if (logined) getAllRequestsDelayed();
        setIsConnected(true);
    }, [checkSession, getAllRequestsDelayed, dispatch, logined]);

    return (
        <SockJsClient
            url={WS_CONNECT_URL}
            topics={topics}
            onMessage={onMessage}
            debug
            onConnect={onConnect}
            ref={stompClientRef}
        />
    );
}

function mapStateToProps(state) {
    const {
        requests: { requests },
        auth: { logined, user },
        program: { program },
    } = state;
    return { requests, logined, user, program };
}

const actionsToProps = {
    checkSession: userActions.checkSession,
    getAllRequestsDelayed: requestsActions.getAllDelayed,
};

export default connect(mapStateToProps, actionsToProps)(WSClient);
